import {
    ANALYTICS_PAYMENT_SETUP_HELP_OPEN,
    ANALYTICS_PAYMENT_SETUP_HELP_CLICK_CHAT,
    ANALYTICS_PAYMENT_SETUP_HELP_CLICK_BACK,
    ANALYTICS_PAYMENT_SETUP_HELP_CLICK_PHONE,
} from '@perpay-web/fintech/constants/actionTypes';

export function analyticsPaymentSetupHelpOpen(payload) {
    return {
        type: ANALYTICS_PAYMENT_SETUP_HELP_OPEN,
        payload,
    };
}

export function analyticsPaymentSetupHelpClickChat(payload) {
    return {
        type: ANALYTICS_PAYMENT_SETUP_HELP_CLICK_CHAT,
        payload,
    };
}

export function analyticsPaymentSetupHelpClickBack(payload) {
    return {
        type: ANALYTICS_PAYMENT_SETUP_HELP_CLICK_BACK,
        payload,
    };
}

export function analyticsPaymentSetupHelpClickPhone(payload) {
    return {
        type: ANALYTICS_PAYMENT_SETUP_HELP_CLICK_PHONE,
        payload,
    };
}
